import slackChannels from 'modules/enums/slack-channels';

const sendSlackNotification = async (
  message,
  channel = slackChannels.alert,
) => {
  const config = {
    method: 'POST',
    // headers: {
    //   Accept: 'application/json',
    //   'Content-Type': 'application/json',
    // },
    body: JSON.stringify({
      attachments: [
        {
          title: message.link,
          title_link: message.link,
        },
        {
          title: message.title,
          text: message.message,
          fields: [
            {
              title:
                message.env && message.platformName
                  ? `${message.env}, ${message.platformName}`
                  : '',
              value: message.datetime,
              // short: false
            },
          ],
        },
      ],
    }),
  };

  try {
    const result = await fetch(channel, config);
    // console.devLog.info('Sent slack', result);
  } catch (err) {
    console.devLog.info(`Error sending slack: ${err}`);
  }
  return null;
};

export default sendSlackNotification;
